//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    },
    type: {
      type: String,
      default: null
    },
    filterKey: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
    }
  },
  methods: {
    getIconName: function (option) {
      if (this.type === 'request') {
        if (this.filterKey === 'bpStateName') {
          if (option.key.startsWith('AS')) {
            return 'mdi-brightness-auto'
          }
        } else if (this.filterKey === 'type') {
          if (option.key.includes('Audit')) {
            return 'mdi-brightness-auto'
          }
        }
      }
    }
  }
}

